import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageLoadSpinner from 'base/ui_components/PageLoadSpinner';

/**
 * A HOC that makes sure the Google Maps API is loaded before rendering the
 * component it wraps.
 *
 * @param Component
 */
const withGoogleLibraryLoaded = Component => {
  class WithLibraryLoaded extends React.Component {
    static propTypes = {
      googleLoaded: PropTypes.bool.isRequired
    };

    render() {
      return (
        <React.Fragment>
          {this.props.googleLoaded ? (
            <Component {...this.props} />
          ) : (
            <PageLoadSpinner />
          )}
        </React.Fragment>
      );
    }
  }
  const mapStateToProps = ({ libraryLoad }) => ({
    googleLoaded: libraryLoad.google
  });
  return connect(mapStateToProps)(WithLibraryLoaded);
};

export default withGoogleLibraryLoaded;
